/** `07:00` → `7:00 am`. Pure, so prerendered and hydrated output always match. */
export function formatClockTime(hhmm: string): string {
  const [h = 0, m = 0] = hhmm.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'am' : 'pm'}`;
}
